export const getTranslations = t => {
  return {
    collabrativeCartDecs: t("kf.cart.label.collbcartdecs"),
    customersCartID: t("kf.cart.lable.customercartid"),
    LoadCart: t("Kf.button.action.loadcart"),
    or: t("kf.global.label.or"),
    createcart: t("kf.cart.lable.createcart"),
    invalidcartidError: t("kf.lookup.cart.error.invalidcartid"),
    invalidEmailCartError: t("kf.lookup.cart.error.invalidcartemail"),
    nocartError: t("kf.lookup.cart.error.nocartfound"),
    createNewOrder: "Create New Order",
  }
}
